import { customFieldsPayload, toPayloadAddress } from "components/BaseForm";

/**
 * Form values as the create and update request body. The API marks the
 * address flagged `is_primary` as the entity's primary address.
 */
export const toEntityPayload = (values, { customFieldConfigs }) => ({
  name: values.name.trim(),
  urls: values.urls,
  external_cc_emails: values.external_cc_emails.trim(),
  account_managers: values.account_managers,
  alternate_names: values.alternate_names
    .map(name => name.trim())
    .filter(Boolean)
    .map(name => ({ name })),
  region_id: values.region_id ?? null,
  country: values.country ?? null,
  addresses: values.addresses.map(toPayloadAddress),
  tags: values.tags,
  custom_fields: customFieldsPayload(customFieldConfigs, values.custom_fields),
});
